import { useState, useCallback, useMemo, useEffect } from "react";
import { debounce } from "lodash";

interface UseDriverSearchProps {
  driversList: any[];
  filterByVehicle: (list: any[]) => any[];
}

export const useDriverSearch = ({ driversList, filterByVehicle }: UseDriverSearchProps) => {
  const [listToShow, setListToShow] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState("");

  const handleSearch = useCallback(
    (searchValue: string) => {
      let filteredList = filterByVehicle([...driversList]);

      if (searchValue !== "") {
        filteredList = filteredList.filter((driver: any) => {
          const name = driver.driverName.toLowerCase();
          const search = searchValue.toLowerCase();
          return name.includes(search);
        });
      }

      setListToShow(filteredList);
    },
    [driversList, filterByVehicle]
  );

  const debouncedHandleSearch = useMemo(
    () => debounce(handleSearch, 300),
    [handleSearch]
  );

  const handleSearchBoxTextChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const value = event.target.value;
      setSearchValue(value);
      debouncedHandleSearch(value);
    },
    [debouncedHandleSearch]
  );

  const resetSearch = useCallback(() => {
    setSearchValue("");
    setListToShow(driversList);
  }, [driversList]);

  return {
    listToShow,
    searchValue,
    handleSearch,
    handleSearchBoxTextChange,
    resetSearch,
  };
};
